"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, createRef, useContext, useEffect, useRef } from "react";
import { getVolumeNumber, useVolume } from "@/stores/use-volume-store";
import { ItemCardMediaAspectRatioProvider } from "./card/ItemCardMedia/ItemCardMediaAspectRatio";
const ItemsMediaContext = createContext(createRef());
export function useItemsMediaContext() {
  return useContext(ItemsMediaContext);
}
export function ItemsMediaContextProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    volume
  } = useVolume();
  const playingVideoRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== volume) {
    t1 = () => {
      if (playingVideoRef.current) {
        playingVideoRef.current.volume = getVolumeNumber(volume);
      }
    };
    t2 = [playingVideoRef, volume];
    $[0] = volume;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children) {
    t3 = <ItemsMediaContext.Provider value={playingVideoRef}><ItemCardMediaAspectRatioProvider>{children}</ItemCardMediaAspectRatioProvider></ItemsMediaContext.Provider>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}